import { Device, DeviceLastTask } from '../types';

export function lastJobCommandLabel(command: string, max = 42): string {
  const cmd = (command || '').trim().replace(/\s+/g, ' ');
  if (!cmd) {
    return '';
  }
  if (cmd.length <= max) {
    return cmd;
  }
  return `${cmd.slice(0, Math.max(1, max - 1))}…`;
}

export function lastJobSortValue(task: DeviceLastTask | null | undefined): number {
  return task?.createdAt || 0;
}

export function deviceOnLatestFirmware(device: Pick<Device, 'firmware' | 'version' | 'latestFirmware'>): boolean {
  const commit = String(device.latestFirmware?.commit || '').slice(0, 7);
  if (!commit) {
    return false;
  }
  return `${device.firmware || ''}${device.version || ''}`.includes(commit);
}
